module.exports = __webpack_public_path__ + "img/onsuly.072ff7b7.svg";